<app-base-widget [card]="false" attr.data-cy="seriesCommitmentChart{{portfolioId()}}{{series().masterId}}">
    <app-gcm-chart chartType="column" [noMerge]="true" [chartStyle]="cumulativeChartStyle" [chartOptions]="chartConfig" />
</app-base-widget>